import {Injectable} from '@angular/core';
import {map, Observable, of} from 'rxjs';
import {IndexedDBRepository} from 'src/app/shared/interface/indexed-db-storage.model';
import {BookingSpace} from '../../../domain/models/space.model';
import {DATABASE_NAME} from 'src/app/config/app.config';
import {STORE_DATABASE} from 'src/app/core/enums/storage/store-database.enum';
import {IApiBookingSpace} from "../../interfaces/booking-space.interface";
import {BookingSpaceMapper} from "../../mappers/space.mapper";

@Injectable({ providedIn: 'root' })
export class BookingSpaceStorageService extends IndexedDBRepository<IApiBookingSpace> {

  readonly dbName = DATABASE_NAME;
  readonly instanceName = STORE_DATABASE.bookingSpaces;

  getAll(): Observable<BookingSpace[]> {
    return this.getItems().pipe(
      map(items => items.map(item => this.mapToModel(item)))
    );
  }

  getById(id: string): Observable<BookingSpace | null> {
    return this.getItem(id).pipe(
      map(item => item ? this.mapToModel(item) : null)
    );
  }

  save(spaces: BookingSpace[]): Observable<BookingSpace[]> {
    if (spaces.length === 0) {
      return of([]);
    }

    const items = spaces.map(space => this.mapToStorageItem(space));

    return this.setItems(items).pipe(
      map(() => spaces)
    );
  }

  clear(): Observable<void> {
    return this.clearAll();
  }

  private mapToModel = (item: IApiBookingSpace): BookingSpace => {
    return BookingSpaceMapper.fromJSON(item);
  };

  private mapToStorageItem = (space: BookingSpace): { key: string; value: IApiBookingSpace } => ({
    key: space?.id,
    value: BookingSpaceMapper.toJSON(space),
  });
}
